import create from 'zustand';

const useStore = create((set) => ({
  userEmail: localStorage.getItem('userEmail') || '',
  selectedAgency: JSON.parse(localStorage.getItem('selectedAgency')) || null, // ✅ Load from storage

  setUserEmail: (email) => {
    localStorage.setItem('userEmail', email);
    set({ userEmail: email });
  },

  resetUserEmail: () => {
    localStorage.removeItem('userEmail');
    set({ userEmail: '' });
  },

  setSelectedAgency: (agency) => {
    localStorage.setItem('selectedAgency', JSON.stringify(agency)); // ✅ Save persistently
    set({ selectedAgency: agency });
  },

  resetSelectedAgency: () => {
    localStorage.removeItem('selectedAgency');
    set({ selectedAgency: null });
  },
}));

export default useStore;

